import React from 'react';
import Icon from '../common/Icons';
import './CompanyListUx.css';

function AnimatedValue({ value, className }) {
  return (
    <strong key={value} className={`${className} co-list-stat__value--tick`} aria-hidden={false}>
      {value}
    </strong>
  );
}

export default function CompanyListStats({ stats, id = 'co-list-stats' }) {
  const { total, active, inactive, activePct, repositoryTotal, isFiltered } = stats;

  return (
    <section
      id={id}
      className={`co-list-stats ${isFiltered ? 'is-filtered' : ''}`}
      aria-label="Statistiques des sociétés affichées"
      aria-live="polite"
      aria-atomic="true"
    >
      {isFiltered ? (
        <div className="co-list-stats__banner" role="status">
          <Icon name="filter" size={14} aria-hidden />
          <span>Indicateurs alignés sur les filtres actifs</span>
          <span className="co-list-stats__banner-meta">
            {total} sur {repositoryTotal} au répertoire
          </span>
        </div>
      ) : null}

      <div className="co-list-stats__grid">
        <article className="co-list-stat co-list-stat--primary">
          <span className="co-list-stat__label">Affichées</span>
          <AnimatedValue value={total} className="co-list-stat__value" />
          <span className="co-list-stat__hint">
            {isFiltered ? 'dans la sélection filtrée' : 'sociétés enregistrées'}
          </span>
        </article>

        <article className="co-list-stat co-list-stat--success">
          <span className="co-list-stat__label">Actives</span>
          <AnimatedValue value={active} className="co-list-stat__value" />
          <div className="co-list-stat__meter" aria-hidden>
            <span
              className="co-list-stat__meter-fill"
              style={{ width: `${activePct}%` }}
            />
          </div>
          <span className="co-list-stat__hint">
            {total > 0 ? `${active}/${total}` : '—'}
          </span>
        </article>

        <article className="co-list-stat co-list-stat--muted">
          <span className="co-list-stat__label">Inactives</span>
          <AnimatedValue value={inactive} className="co-list-stat__value" />
          <span className="co-list-stat__hint">hors service</span>
        </article>
      </div>
    </section>
  );
}
